var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraingles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Large-Triangles_1_",
    "data-name": "Large-Triangles (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 711.067,
    viewBox: "0 0 959 711.067",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M68.5,150,0,268.511H137Z",
    transform: "translate(68.5 -31.489)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M68.5,118.511,137,0H0Z",
    transform: "translate(68.5)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M248.5,118.511,317,0H180Z",
    transform: "translate(25.5)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M428.5,150,360,268.511H497Z",
    transform: "translate(-17.5 -31.489)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M428.5,118.511,497,0H360Z",
    transform: "translate(-17.5)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M608.5,150,540,268.511H677Z",
    transform: "translate(-60.5 -31.489)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M608.5,118.511,677,0H540Z",
    transform: "translate(-60.5)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M788.5,150,720,268.511H857Z",
    transform: "translate(-103.5 -31.489)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M788.5,118.511,857,0H720Z",
    transform: "translate(-103.5)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M968.5,150,900,268.511h137Z",
    transform: "translate(-146.5 -31.489)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M968.5,118.511,1037,0H900Z",
    transform: "translate(-146.5)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M68.5,450,0,568.511H137Z",
    transform: "translate(68.5 -94.466)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M68.5,418.511,137,300H0Z",
    transform: "translate(68.5 -62.978)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M248.5,450,180,568.511H317Z",
    transform: "translate(25.5 -94.466)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M248.5,418.511,317,300H180Z",
    transform: "translate(25.5 -62.978)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M428.5,450,360,568.511H497Z",
    transform: "translate(-17.5 -94.466)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M428.5,418.511,497,300H360Z",
    transform: "translate(-17.5 -62.978)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M608.5,450,540,568.511H677Z",
    transform: "translate(-60.5 -94.466)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M608.5,418.511,677,300H540Z",
    transform: "translate(-60.5 -62.978)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M788.5,450,720,568.511H857Z",
    transform: "translate(-103.5 -94.466)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M788.5,418.511,857,300H720Z",
    transform: "translate(-103.5 -62.978)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M968.5,450,900,568.511h137Z",
    transform: "translate(-146.5 -94.466)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M968.5,418.511,1037,300H900Z",
    transform: "translate(-146.5 -62.978)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M68.5,750,0,868.511H137Z",
    transform: "translate(68.5 -157.444)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M248.5,750,180,868.511H317Z",
    transform: "translate(25.5 -157.444)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M248.5,718.511,317,600H180Z",
    transform: "translate(25.5 -125.955)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M428.5,718.511,497,600H360Z",
    transform: "translate(-17.5 -125.955)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M608.5,750,540,868.511H677Z",
    transform: "translate(-60.5 -157.444)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M608.5,718.511,677,600H540Z",
    transform: "translate(-60.5 -125.955)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M788.5,750,720,868.511H857Z",
    transform: "translate(-103.5 -157.444)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M788.5,718.511,857,600H720Z",
    transform: "translate(-103.5 -125.955)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M968.5,750,900,868.511h137Z",
    transform: "translate(-146.5 -157.444)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M158.5,0,90,118.511H227Z",
    transform: "translate(47)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M338.5,0,270,118.511H407Z",
    transform: "translate(4)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M518.5,0,450,118.511H587Z",
    transform: "translate(-39)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M878.5,0,810,118.511H947Z",
    transform: "translate(-125)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-21.5,300-90,418.511H47Z",
    transform: "translate(90 -62.978)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-21.5,268.511,47,150H-90Z",
    transform: "translate(90 -31.489)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M158.5,300,90,418.511H227Z",
    transform: "translate(47 -62.978)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M158.5,268.511,227,150H90Z",
    transform: "translate(47 -31.489)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M338.5,300,270,418.511H407Z",
    transform: "translate(4 -62.978)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M338.5,268.511,407,150H270Z",
    transform: "translate(4 -31.489)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M518.5,300,450,418.511H587Z",
    transform: "translate(-39 -62.978)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M518.5,268.511,587,150H450Z",
    transform: "translate(-39 -31.489)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M698.5,300,630,418.511H767Z",
    transform: "translate(-82 -62.978)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M698.5,268.511,767,150H630Z",
    transform: "translate(-82 -31.489)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M878.5,300,810,418.511H947Z",
    transform: "translate(-125 -62.978)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M878.5,268.511,947,150H810Z",
    transform: "translate(-125 -31.489)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M-21.5,600-90,718.511H47Z",
    transform: "translate(90 -125.955)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-21.5,568.511,47,450H-90Z",
    transform: "translate(90 -94.466)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M158.5,600,90,718.511H227Z",
    transform: "translate(47 -125.955)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M158.5,568.511,227,450H90Z",
    transform: "translate(47 -94.466)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M338.5,600,270,718.511H407Z",
    transform: "translate(4 -125.955)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M338.5,568.511,407,450H270Z",
    transform: "translate(4 -94.466)",
    fill: "rgba(153,153,153,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M518.5,568.511,587,450H450Z",
    transform: "translate(-39 -94.466)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M698.5,600,630,718.511H767Z",
    transform: "translate(-82 -125.955)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M878.5,600,810,718.511H947Z",
    transform: "translate(-125 -125.955)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M878.5,568.511,947,450H810Z",
    transform: "translate(-125 -94.466)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M-21.5,868.511,47,750H-90Z",
    transform: "translate(90 -157.444)",
    fill: "rgba(221,221,221,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M158.5,868.511,227,750H90Z",
    transform: "translate(47 -157.444)",
    fill: "rgba(68,68,68,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M338.5,868.511,407,750H270Z",
    transform: "translate(4 -157.444)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M518.5,868.511,587,750H450Z",
    transform: "translate(-39 -157.444)",
    fill: "rgba(170,170,170,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M698.5,868.511,767,750H630Z",
    transform: "translate(-82 -157.444)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M878.5,868.511,947,750H810Z",
    transform: "translate(-125 -157.444)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1058.5,300,990,418.511h137Z",
    transform: "translate(-168 -62.978)",
    fill: "rgba(34,34,34,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1058.5,268.511,1127,150H990Z",
    transform: "translate(-168 -31.489)",
    fill: "rgba(255,255,255,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1058.5,600,990,718.511h137Z",
    transform: "translate(-168 -125.955)",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1058.5,568.511,1127,450H990Z",
    transform: "translate(-168 -94.466)",
    fill: "rgba(102,102,102,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1058.5,868.511,1127,750H990Z",
    transform: "translate(-168 -157.444)",
    fill: "rgba(221,221,221,0.1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraingles);
export default __webpack_public_path__ + "static/media/traingles.d69ce10a.svg";
export { ForwardRef as ReactComponent };